import styled from "styled-components";
import Icon from "../../../components/icon";
import { ReactComponent as OfferElipse } from "../../../assets/icons/offer-elipse.svg";
import { ReactComponent as OfferElipseBg } from "../../../assets/icons/offer-elipsebg.svg";
import { ReactComponent as OfferElipseFrame } from "../../../assets/icons/offer-elipse-frame.svg";
import { theme } from "../../../helpers/theme";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { url, urlClient } from "../../../utils/url";
import SessionService from "../../../services/session-service";
import { useMutation, useQuery } from "@tanstack/react-query";
import { generateOffers } from "../../../services/offers/generate-offers";
import { TokenForUnlogedClient } from "../../../types/session-service";
import { LoadingBackDrop } from "../../../components/loader";
import { GenerateOffersResponse } from "../../../services/offers/generate-offers/types";
import { AxiosResponse } from "axios";
const OfferFormCreate = () => {
  const navigate = useNavigate();
  const user = SessionService.getUser();
  const isLoged = user && user.token_dostepu !== null ? true : false;
  const orderNumber=SessionService.getOrderNumber()?SessionService.getOrderNumber():null;


  const  GenerateOfferQuery = useQuery(["generateOffer"], () =>  generateOffers({
    numer_zamowienia: (SessionService.getOrderIdentification()).numer_zamowienia
  }), {
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    onSuccess(res) {
     
      if(res.data.payload){

        if(res.data.payload.token!==null){
          SessionService.setTokenForUnlogedClient({
          token: res.data.payload.token,
          });
        }
      
        isLoged 
        ? navigate(urlClient.offerView)
        : navigate(url.offerView)
        
      }
      else{
        isLoged 
        ? navigate(urlClient.offerView)
        : navigate(url.offerView)

      }
    },
  });


  return (
    <OfferFormCreateWrapper>
      <OfferFormCreateIconsWrapper>
        <OfferElipseBgWrapper>
          <Icon icon={<OfferElipse />} />
        </OfferElipseBgWrapper>

        <OfferElipseBgWrapper>
          <Icon icon={<OfferElipseBg />} />
        </OfferElipseBgWrapper>

        <OfferElipseBgWrapper>
          <Icon icon={<OfferElipseFrame />} />
        </OfferElipseBgWrapper>
      </OfferFormCreateIconsWrapper>
      <OfferFormCreateInfo>
        Twoja oferta jest już w drodze...
      </OfferFormCreateInfo>
    </OfferFormCreateWrapper>
  );
};

export default OfferFormCreate;
const OfferFormCreateWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  //   @media (max-width: ) {
  //     margin-top: 0px;
  //   }
`;
const OfferFormCreateIconsWrapper = styled.div`
  width: 100%;
  display: flex;
  height: 350px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const OfferFormCreateInfo = styled.span`
  font-family: ${theme.fonts.interBold};
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  margin: 0 10px;
`;
const OfferElipseBgWrapper = styled.div`
  position: absolute;
`;
